import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PayGatewayDialogComponent } from '../pay-gateway-dialog/pay-gateway-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pay-gateway',
  templateUrl: './pay-gateway.component.html',
  styleUrls: ['./pay-gateway.component.scss']
})
export class PayGatewayComponent implements OnInit {
  paymentGatewayList: any
  payGatewayListForm: FormGroup;
  payGatewaySearchForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  totalItems = 0;
  pageSize = 10;
  currentPage = 1;
  pageSizeOptions: number[] = [5, 10, 20];
  setIntervalSearch: any;
 

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getPaymentGatewayData();
    this.payGatewayListForm = this.fb.group({
      gatewayName: new FormControl(''),
      isActive: new FormControl('LIKE'),
    });
    this.payGatewaySearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.spinner.show()
    let payload = {}
    payload['SearchString'] = this.payGatewaySearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize; 
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchPaymentGateway(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.paymentGatewayList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.spinner.hide()
        this.paymentGatewayList = [];
        this.totalItems = 0;
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.paymentGatewayList = [];
    });
    },1000)
    
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(PayGatewayDialogComponent, {
      width: '35%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getPaymentGatewayData();
      this.payGatewaySearchForm.controls['gatewayName'].setValue('');
    });
   }

   editData(k) {
    const dialogRef = this.dialog.open(PayGatewayDialogComponent, {
      width: '35%',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getPaymentGatewayData();
      this.payGatewaySearchForm.controls['gatewayName'].setValue('');
    });
   }

   onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getPaymentGatewayData();
  }

   getPaymentGatewayData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getPaymentGateway(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.paymentGatewayList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
        this.totalItems = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.paymentGatewayList = [];
    });
   }

}
